import Page from '../page';
import {MANAGE_MAP_EVENT} from "../../helpers/map-manager";

export default class CinemasIndex extends Page {
    constructor(...args) {
        super(...args);

    }

    bind() {
        super.bind();

        if( this.Components.hasOwnProperty('Mapbox') && this.Components.hasOwnProperty('Menu') ) {
            this.Components['Mapbox'].on( MANAGE_MAP_EVENT.CLICK_PIN, () => {
                this.Components['Menu'].emit( MANAGE_MAP_EVENT.CLICK_PIN );
            } );

            this.Components['Mapbox'].on( MANAGE_MAP_EVENT.CLOSE_POPUP, () => {
                this.Components['Menu'].emit( MANAGE_MAP_EVENT.CLOSE_POPUP );
            } );
        }
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}


// WEBPACK FOOTER //
// src/js/pages/cinemas/cinemas.js